import { useQuery } from "@tanstack/react-query";
import TenantSettingsAPI from "../api/tenant-settings";

export const useTenantSettings = () => {
  const { data: { data: settingsArray } = { data: [] } } = useQuery({
    queryKey: ["tenant-settings", "list"],
    queryFn: async () => {
      const response = await TenantSettingsAPI.getTenantSettings();
      return response; // Return the whole response
    },
  });

  return { tenantSettings: settingsArray };
};
